import { getCsrfTokenFromDocumentCookie } from "./auth-api"

export type BirthdayConfigWire = {
  enabled: boolean
  announcementChannelId: string | null
  birthdayRoleId: string | null
  announcementHour: number
  messageTemplate: string
  pingCelebrant: boolean
}

export type BirthdayConfigInput = Partial<BirthdayConfigWire>

const readErrorMessage = async (
  response: Response,
  fallback: string,
): Promise<string> => {
  try {
    const body = (await response.json()) as {
      error?: { message?: string }
      message?: string
    }
    return body.error?.message ?? body.message ?? fallback
  } catch {
    return fallback
  }
}

const jsonHeaders = (): Record<string, string> => {
  const csrfToken = getCsrfTokenFromDocumentCookie()
  if (!csrfToken) {
    throw new Error("Missing CSRF token")
  }
  return {
    "content-type": "application/json",
    "x-csrf-token": csrfToken,
  }
}

export const birthdaysApi = {
  getConfig: async (): Promise<BirthdayConfigWire> => {
    const response = await fetch("/api/birthdays/config", {
      method: "GET",
      credentials: "include",
    })
    if (!response.ok) {
      throw new Error(
        await readErrorMessage(response, "Failed to load birthday config"),
      )
    }
    const payload = (await response.json()) as { item: BirthdayConfigWire }
    return payload.item
  },
  updateConfig: async (
    input: BirthdayConfigInput,
  ): Promise<{ item: BirthdayConfigWire; warnings?: string[] }> => {
    const response = await fetch("/api/birthdays/config", {
      method: "PUT",
      credentials: "include",
      headers: jsonHeaders(),
      body: JSON.stringify(input),
    })
    if (!response.ok) {
      throw new Error(
        await readErrorMessage(response, "Failed to save birthday config"),
      )
    }
    return (await response.json()) as {
      item: BirthdayConfigWire
      warnings?: string[]
    }
  },
}
